import styled from 'styled-components'
import Icon from './Icon'

const UserIcon = styled(Icon).attrs({
  type: 'user',
})``

export default UserIcon
